export default {
  account: {
    settingBtn: '账号设置',
    submitBtn: '保存',
    cancelBtn: '取消',
    uploadSuccess: '上传成功！',
    submitSuccess: '保存成功！',
    formLabel: {
      account: '用户名',
      photo: '头像',
      source: '主商城',
      email: '账号邮箱',
      time: '账号期限',
    },
  },
  password: {
    subBtnText: '确认',
    cancelBtnText: '取消',
    pwdMsg: '两次密码不一致',
    oldPassword: '旧密码',
    oldPasswordMsg: '请输入旧密码',
    newPassword: '新密码',
    newPasswordMsg: '请输入新密码',
    pw2: '确认新密码',
    passwordTitle: '更改密码'
  },
};
